import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Button, Card, CardActions, CardContent, CardMedia, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from 'react-router-dom';
import { getImageUrl, truncateWords } from '../utils/functions';
import cardBackground1 from '../assets/c-background1.jpg';
import cardBackground2 from '../assets/c-background2.jpg';
import cardBackground3 from '../assets/c-background3.jpg';

const InternshipCard = ({internship, intern, index, companyImage }) => {
    const navigate = useNavigate();
    const backgrounds = [cardBackground1, cardBackground2, cardBackground3];
    const backgroundImage = backgrounds[index % 3];

    // Use intern data if available, otherwise fallback to minimal display
    const displayData = intern || {};
    const internshipId = internship?.uid || intern?.internshipUid;

    return (
        <Card key={internshipId} sx={{
            // maxWidth: 345, 
            marginBottom: 2,
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            height: '300px',
            minHeight: '300px',
            borderRadius: '10px'
        }}>
            <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(5px)',
                transform: 'scale(1.1)',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                }
            }} />
            <Box sx={{ 
                position: 'relative', 
                zIndex: 1,
                color: 'white'
            }}>
                {<CardMedia
                    component="img"
                    height="100"
                    style={{objectFit: 'contain', padding: 1, visibility: companyImage ? 'visible' : 'hidden'}}
                    image={companyImage}
                    alt={displayData.name}
                />}
                <CardContent sx={{minHeight: '100px'}}>
                    <Typography variant={'h5'}><strong>{displayData?.name?.replace(/\b\w/g, char => char.toUpperCase()) || 'Pending Intern'}</strong></Typography>
                    <Typography sx={{mb: 1}} variant={'body1'}>{displayData?.jobTitle?.replace(/\b\w/g, char => char.toUpperCase()) || ''}</Typography>
                    <Typography variant={'body1'}>
                        {displayData?.jobDescription ? truncateWords(displayData.jobDescription, 10) : ''}
                    </Typography>
                </CardContent>
                <CardActions sx={{p: 2}}>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={() => navigate(`/internship/${internshipId}`)}
                        sx={{
                            bgcolor: 'rgba(255, 255, 255, 0.15)',
                            color: 'white',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '12px',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.875rem',
                            px: 3,
                            py: 1,
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.25)',
                                border: '1px solid rgba(255, 255, 255, 0.5)',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)'
                            },
                            '&:active': {
                                transform: 'translateY(0)'
                            }
                        }}
                    >
                        View Details
                    </Button>
                </CardActions>
            </Box>
        </Card>
    );
};

export default InternshipCard; 